import {Store, createStore} from 'vuex';
import BaseMapStylesDialogModule, {
  BaseMapStylesState
} from "../.././base_map_dialog/store/modules/BaseMapStylesDialogModule";
import HikeMapModule, { HikeMapState } from "./modules/HikeMapModule";
import BaseMapDataPOIsModule, { BaseMapDataPOIsState } from "../../base_map_dialog/store/modules/BaseMapDataPOIsModule";
import BaseMapDataOverlaysModule, { BaseMapDataOverlaysState } from "../../base_map_dialog/store/modules/BaseMapDataOverlaysModule";
import WaypointDialogModule, { WaypointDialogState } from "../../waypoint_dialog/store/module/WaypointOptionsDialogModule";

export interface RootState {
  mapStyles: BaseMapStylesState
  hikeMap: HikeMapState
  mapDataOverlays: BaseMapDataOverlaysState
  mapDataPOIs: BaseMapDataPOIsState
  waypoints: WaypointDialogState
}

const store: Store<RootState> = createStore({
  modules: {
    mapStyles: BaseMapStylesDialogModule,
    hikeMap: new HikeMapModule(),
    mapDataOverlays: BaseMapDataOverlaysModule,
    mapDataPOIs: BaseMapDataPOIsModule,
    waypoints: WaypointDialogModule,
  }
})

export default store;
